import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    price: { type: Number, required: true },
    displayPrice: { type: Boolean, required: true, default: false },
    purpose: { type: Number, required: true },
    currency: { type: String, required: true },
    makeOffer: { type: Boolean, required: false, default: false },
    labelClass: { type: String, required: false, default: "text-14 text-white bg-brand px-12 py-4" }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as { price: number, displayPrice: boolean, purpose: number, currency: string, makeOffer: boolean, labelClass: string }



const computedPrice = computed(() => {
    let symbol: string = props.currency;
    const price: string = `${props.price}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    if (props.purpose === 1) {
        return `${symbol} ${price}`;
    } else if (props.purpose === 2) {
        return `${symbol} ${price}/maand`;
    } else if (props.purpose === 5) {
        return `In optie`;
    }

    return "";
});

const __returned__ = { props, computedPrice }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})